import { Controller } from 'react-hook-form'
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import { PropsValue, Select } from 'chakra-react-select'

import { useEventFormOptions } from '@hooks/useEventFormOptions'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'

import { Option } from '../utils'

export function PeriodSelect() {
    const { zodForm, isFormDisabled } = useMatchEditorFormContext()
    const { periods } = useEventFormOptions()

    if (!periods.length) {
        return null
    }

    return (
        <Controller
            control={zodForm.control}
            name="period_number"
            render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                <FormControl isInvalid={!!error} isRequired isDisabled={isFormDisabled} mb={8}>
                    <FormLabel htmlFor="period_number">Select period</FormLabel>
                    <Select
                        id="period_number"
                        name={name}
                        ref={ref}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value as unknown as PropsValue<Option>}
                        placeholder="Select period"
                        options={periods}
                    />
                    <FormErrorMessage>{zodForm.formState.errors.period_number?.message}</FormErrorMessage>
                </FormControl>
            )}
        />
    )
}
